import './MediaModal.css';

function MediaModal({ mediaSrc, isVideo, closeModal }) {
  return (
    <div className="media-modal-overlay" onClick={closeModal}>
      <div
        className="media-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="media-close-btn"
          onClick={closeModal}
          aria-label="Close"
        >
          &times;
        </button>
        {isVideo ? (
          <video
            className="media-modal-media"
            src={mediaSrc}
            controls
            autoPlay
            loop
          />
        ) : (
          <img
            className="media-modal-media"
            src={mediaSrc}
            alt="Expanded media"
          />
        )}
      </div>
    </div>
  );
}

export default MediaModal;
